/**
 * Facility-scoped EV Continue validation flag from Firestore healthcare_facility config.
 *
 * @module useValidateEvEnabled
 */
import { useSelector } from "react-redux";
import { isHealthFacilityFeatureEnabled } from "../data-model/healthFacility";
import { RootState } from "../redux/store/store";

/**
 * Returns whether EV coverage Continue should run required-field validation
 * for the logged-in user's healthcare facility (`validate_ev` in `feature_config` / facility doc).
 *
 * @returns `true` when Continue validation is enabled for the facility.
 */
export const useValidateEvEnabled = (): boolean =>
  useSelector((state: RootState) =>
    isHealthFacilityFeatureEnabled(
      state.singleHealthFacilityDetails.data,
      "validate_ev",
    ),
  );
